const options = {
  data() {
    return {
      calculatorOptions: {
        zoningDistrict: ["RM-1", "RM-2", "RM-3", "RM-4", "RMX-1", "RMX-2", "RMX-3", "IRMX", "CMX-1", "CMX-2", "CMX-2.5", "CMX-3", "CMX-4", "CMX-5"],
        affordabilityLevel:["lowIncome", "moderateIncome"],
        overlays: ["greenRoof", "minMixed", "todDevelopement"],
        sFHA: ["Special Flood Hazard Area"],
      },
    };
  },
};

export default options;